import { plural } from "@lingui/macro"
import * as Occupancy from "@ssc-booking/api-contracts/src/occupancy"

export const formatTotalOccupancyValue = (occupancy: Occupancy.Occupancy): string => {
    const total = Occupancy.totalGuests(occupancy)
    return plural(total || 0, {
        one: "Single Occupancy",
        other: "# Guests",
    })
}
